import { useParams } from '@tanstack/react-router';

import { CompanyOverviewPage } from '../../components/CompanyOverviewPage';
import { SuppliersTable } from '../detail/components/SuppliersTable';

export const SupplierCompaniesPage = () => {
    const { groupId } = useParams({ from: '/_app/supplier-groups/$groupId/companies' });

    return (
        <CompanyOverviewPage>
            <SuppliersTable groupId={groupId} />
        </CompanyOverviewPage>
    );
};
